import React,  { Component } from "react"
import './index.scss'

import playIcon from '@/images/newHome/play.svg'
import HtDialogVideo from '@/components/HtDialogVideo'

class HtVideo extends Component {

    state = {
        // 视频播放状态
        isPlay: false,
        showDialog: false
    }

    openShowDialog = () => {
        if(!this.props.isDialogPlay){
            return
        }
        this.setState({
            showDialog: true
        })
    }

    closeDialog = () => {
        this.setState({
            showDialog: false
        })
        
    }

    playVideo = () => {
        this.refs.video && this.refs.video.play()
    }

    pauseVideo = () => {
        // this.refs?.video.pause()
    }

    play = () => {
        this.setState({
            isPlay: true
        })
    }

    seeking = () => {
        this.setState({
            isPlay: true
        })
    }

    seeked = () => {
        console.log(3)
    }

    pause = (e) => {
        this.setState({
            isPlay: false
        })
    }

    render(){
        return (
            <div className="ht-video" onClick={this.openShowDialog}>
                    {
                        this.props.children ? (this.props.children) : (
                            <div className="ht-video-box">
                                <video className="video" 
                                    ref="video" 
                                    src={this.props.src} 
                                    controls={this.state.isPlay || this.props.controls} 
                                    poster={this.props.poster}
                                    onSeeking={this.seeking} 
                                    onSeeked={this.seeked} 
                                    onPlay={this.play}
                                    onPause={this.pause}
                                ></video>
                                {
                                    !this.state.isPlay && <img className="play-icon"  src={playIcon} onClick={this.playVideo} />
                                }
                                
                            </div>
                        )
                    }
                <HtDialogVideo show={this.state.showDialog} src={this.props.src} poster={this.props.poster} close={this.closeDialog} />
             </div>
        )
    }
}

export default HtVideo